import { useField } from 'formik';
import { Form, Label } from 'semantic-ui-react';

interface Props {
    placeholder: string;
    name: string;
    rows: number;
    label?: string;
    onChange?: (value: string) => void;
    // onBlur?: (value: string) => void;
}

export default function MyTextArea(props: Props) {
    const [field, meta, helpers] = useField(props.name); 
    const { setValue } = helpers;
    const msgMax = 200;

    return (
        <Form.Field error={meta.touched && !!meta.error}>
            <label>{props.label}</label>
            <textarea {...field} {...props}
                // onBlur={(e) => {
                //     let value = e.currentTarget.value;
                //     setValue(value); // phone formatter
                //     console.log('onBlur');
                //     console.log(e);
                //     console.log(value);
                //     if(props.onBlur)
                //         props.onBlur(value);
                // }}
                onChange={(e) => {
                    let value = e.currentTarget.value;
                    
                    if(props.onChange && msgMax >= value.length) {
                        setValue(value); // phone formatter
                        props.onChange(value);
                    }
                }}
            />
            {msgMax === field.value.length &&
                <Label basic color='red'>You have reached the maximum number of message.</Label>
            }
            {meta.touched && meta.error ? (
                <Label basic color='red'>{meta.error}</Label>
            ) : null}
        </Form.Field>
    )
}